export default {
    data() {
        return {
            skills: ['Read', 'Write', 'Speak']
        }
    }
}
